var map = {
	"./box-upload.svg": 8892,
	"./calendar.svg": 6453,
	"./close.svg": 9657,
	"./copy.svg": 6620,
	"./db.svg": 825,
	"./edit.svg": 6163,
	"./folder-eye.svg": 1623,
	"./forms.svg": 4372,
	"./list.svg": 6451,
	"./menu.svg": 9694,
	"./play.svg": 7817,
	"./plus.svg": 7991,
	"./profile.svg": 3298,
	"./seo.svg": 8130,
	"./square.svg": 90,
	"./statistic.svg": 863,
	"./sync.svg": 5998,
	"./text.svg": 5074,
	"./vector-down.svg": 8223
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1295;